import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const appSlice = createSlice({
  name: 'app',
  initialState: {
    isLdInitialized: false,
    riskAlertTaskId: null as string | null,
    activeOpenItemsTab: undefined as string | undefined,
    zendeskAuthenticatedUserId: undefined as string | undefined,
  },
  reducers: {
    setLdInitialized: (state) => {
      state.isLdInitialized = true
    },
    setRiskAlertTaskId: (state, action: PayloadAction<string | null>) => {
      state.riskAlertTaskId = action.payload
    },
    setActiveOpenItemsTab: (state, action: PayloadAction<string>) => {
      state.activeOpenItemsTab = action.payload
    },
    setZendeskAuthenticatedUserId: (state, action: PayloadAction<string | undefined>) => {
      state.zendeskAuthenticatedUserId = action.payload
    },
  },
})

export const { setLdInitialized, setRiskAlertTaskId, setActiveOpenItemsTab, setZendeskAuthenticatedUserId } =
  appSlice.actions
export default appSlice.reducer
